<template>
  <v-container fluid>

    <!-- title / add  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-toolbar flat>
        <v-toolbar-title class="text-uppercase body-1 font-weight-medium">Gas Costs</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>

        <div class="flex-grow-1"></div>

        <!-- add ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" fab small text>
                    <v-icon large color="orange darken-2">mdi-plus-circle-outline</v-icon>
                </v-btn>
            </template>
            <!-- add dialog ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-card>
            <v-card-text>
                <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs6 sm5 md-4 mr-3>
                    <v-text-field
                        v-model="editedItem.component"
                        label="Component Type"
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                    <v-text-field
                        v-model="editedItem.name"
                        label="Name"
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 mr-3>
                    <v-text-field
                        v-model="editedItem.deliveryId"
                        label="Delivery ID"
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8>
                    <v-text-field
                        v-model="editedItem.deliveryPoint"
                        label="Delivery Point"
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 mr-3>
                    <v-text-field
                        v-model="editedItem.commodityPrice"
                        label="Commodity Price"
                        suffix="$/MMBtu"
                    ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3>
                    <v-text-field
                        v-model="editedItem.basketPercent"
                        label="Basket %"
                        suffix="%"
                    ></v-text-field>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="primary" text @click.native="close"
                >Cancel</v-btn
                >
                <v-btn small color="primary" @click.native="saveComponent"
                >Save</v-btn
                >
            </v-card-actions>
            </v-card>
        </v-dialog>
    </v-toolbar>

    <!-- table ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-data-table
        :headers="headers"
        :items="components"
        :search="search"
        :sort-by="['name']"
        :sort-desc="[false]"
        hide-default-footer
        multi-sort
        class="mb-5">

        <!-- no-data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <template slot="no-data" class="text-left">
            <v-alert :value="true" color="info" dark>
            <span class="title text-left">
                <v-icon color="orange">warning</v-icon>
                No components found.
            </span>
            </v-alert>
        </template>

        <!-- content  ~*~*~*~*~*~*~*~* -->
        <template v-slot:item.basketPercent="{ item }">
            {{ item.basketPercent | $_percentFilter_calcPercentNoCap }}
        </template>
        <template v-slot:item.commodityPrice="{ item }">
            {{ item.commodityPrice | $_currencyFilter_usd }}
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon @click="editItem(item)" class="mr-2" color="primary">
                edit
            </v-icon>
            <v-icon @click="deleteItem(item)" color="red darken-2">
              delete_forever
            </v-icon>
        </template>

        <!-- content summary  ~*~*~*~*~*~*~*~* -->            
        <template v-slot:body.append>
            <tr class="grey lighten-3">
                <td class=" font-weight-bold subtitle-1 text-uppercase compress pt-3 pb-3">Totals:</td>
                <td></td>
                <td></td>
                <td></td>
                <td class="font-weight-bold subtitle-1 text-uppercase compress text-right">
                {{ totals.basketPercent | $_percentFilter_calcPercentNoCap }}
                </td>
                <td class="font-weight-bold subtitle-1 text-uppercase compress text-right">
                {{ totals.commodityPrice | $_currencyFilter_usd }}
                </td>
                <td class="text-center">
                <span class="font-weight-bold subtitle-1 text-uppercase compress pa-2" style="border:1px solid;">
                    {{ totals.deliveredGasPrice | $_currencyFilter_usd }}
                </span>
                </td>
                <td></td>
            </tr>
        </template>

    </v-data-table>

    <!-- pricing / totals ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-layout justify-space-between>
        <v-flex xs7>
            <v-card flat>
                <v-card-text>
                <form>
                    <v-layout row wrap>
                    <v-flex xs3>
                        <v-text-field
                        v-model="form.ldcTransport"
                        label="LDC Transport"
                        suffix="$/MMBtu"
                        required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs3>
                        <v-text-field
                        v-model="form.balancingBuffer"
                        label="Balancing Buffer"
                        suffix="$/MMBtu"
                        required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs3>
                        <v-text-field
                        v-model="form.heatRate"
                        label="Heat Rate"
                        suffix="Btu/kwh"
                        required
                        ></v-text-field>
                    </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                    <v-flex xs3>
                        <v-text-field
                        v-model="form.operatingMargin"
                        label="Operating Margin "
                        suffix="$/MWh"
                        required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs3>
                        <v-text-field
                        v-model="form.startupMargin"
                        label="Startup Margin "
                        suffix="$/MWh"
                        required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs1></v-flex>
                    <v-flex xs2>
                        <v-text-field
                        v-model="form.otherCost"
                        label="Other"
                        suffix="$/MWh"
                        required
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-layout class="justify-end align-end">
                        <v-btn
                            @click="saveMeta"
                            small
                            class="mt-4"
                            color="primary"
                            >Save</v-btn
                        >
                        </v-layout>
                    </v-flex>
                    </v-layout>
                </form>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-flex xs2 pt-3>
            <CoreCardStat class="mt-5" cardcolor="primary">
                <template slot="subtitle"> </template>
                <template slot="stat_value">
                    <span class="white--text">{{ totals.bidPrice | $_currencyFilter_usd }}</span>
                </template>
                <template slot="stat_description">
                    <span class="white--text">BID PRICE</span>
                </template>
            </CoreCardStat>                
        </v-flex>
        <v-flex xs2 pt-3>
            <CoreCardStat class="mt-5" cardcolor="primary">
                <template slot="subtitle"> </template>
                <template slot="stat_value">
                    <span class="white--text">{{ totals.costToRun | $_currencyFilter_usd }}</span>
                </template>
                <template slot="stat_description">
                    <span class="white--text">COST TO RUN</span>
                </template>
            </CoreCardStat>                

        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ConstraintService from '@/services/ConstraintService'
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    pagination: {
      rowsPerPage: 10,
      sortBy: 'basketPercent'
    },
    form: {
      heatRate: '9100',
      startupMargin: '25.00',
      operatingMargin: '15.25',
      balancingBuffer: '0.185',
      otherCost: '1.00',
      ldcTransport: '1.04'
    },
    search: '',
    dialog: false,
    headers: [
      { text: '', sortable: false, value: 'component' },
      { text: 'Name', sortable: true, value: 'name' },
      { text: 'Delivery Point', sortable: true, value: 'deliveryPoint' },
      { text: 'Delivery Id', sortable: true, value: 'deliveryId' },
      { text: 'Basket%', sortable: true, value: 'basketPercent', align: 'right'},
      { text: 'Price ($/MMBtu)', sortable: true, value: 'commodityPrice', align: 'right'},
      { text: '', value: '', align: 'right', sortable: false },
      { text: '', value: 'actions', align: 'right', sortable: false }
    ],
    components: [],
    totals: {
      basketPercent: 0,
      commodityPrice: 0,
      deliveredGasPrice: 0,
      bidPrice: 0,
      costToRun: 0
    },
    editedIndex: -1,
    editedItem: {
      component: '',
      name: '',
      deliveryPoint: '',
      deliveryId: '',
      basketPercent: 0,
      commodityPrice: 0
    },
    defaultItem: {
      component: 'Pipeline',
      name: '',
      deliveryPoint: '',
      deliveryId: '',
      basketPercent: 0,
      commodityPrice: 0
    },
    costToRunConstraint: {},
    bidPriceConstraint: {}
  }),
  computed: {
    ...mapGetters(['getFacilityId'])
  },
  watch: {
    dialog(val) {
      val || this.close()
      this.calculate()
    },
    components() {
      this.calculate()
    }
  },
  created() {
    this.initialize()
    this.fetch()
    // get master ids for two affected facility constraints
  },
  methods: {
    initialize() {
      this.components = [
        {
          component: 'Pipeline',
          name: 'Transco',
          deliveryPoint: 'Rivervale',
          deliveryId: '1006224',
          basketPercent: 0.5,
          commodityPrice: 3.32
        },
        {
          component: 'Pipeline',
          name: 'TETCO',
          deliveryPoint: 'ETG-Ringoes',
          deliveryId: '70804',
          basketPercent: 0.5,
          commodityPrice: 2.86
        }
      ]
    },
    fetch() {
      ConstraintService.getFacilityConstraintByName(
        this.getFacilityId,
        encodeURI('Bid Price')
      )
        .then(response => {
          this.bidPriceConstraint = response.data
        })
        // .catch(error => { })

      ConstraintService.getFacilityConstraintByName(
        this.getFacilityId,
        encodeURI('Cost to Run')
      )
        .then(response => {
          this.costToRunConstraint = response.data
        })
        // .catch(error => { })
    },
    editItem(item) {
      this.editedIndex = this.components.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.components.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.components.splice(index, 1)
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    calculate() {
      this.totals.basketPercent = 0
      this.totals.commodityPrice = 0
      this.totals.deliveredGasPrice = 0
      this.totals.bidPrice = 0
      this.totals.costToRun = 0

      let basketTotal = 0
      let priceBasket = 0

      for (var i = 0; i < this.components.length; i++) {
        basketTotal += parseFloat(this.components[i].basketPercent)
        priceBasket +=
          parseFloat(this.components[i].basketPercent) *
          parseFloat(this.components[i].commodityPrice)
      }
      this.totals.basketPercent = basketTotal
      this.totals.commodityPrice = priceBasket

      this.totals.deliveredGasPrice = parseFloat(
        this.totals.commodityPrice + this.form.ldcTransport
      )

      // calculate report total
      // (total commodity + transport + balancing) * (heatRate/1000) + other + operating + startup
      /*
        console.log("commodityPrice", this.totals.commodityPrice)
        console.log("ldcTransport", this.form.ldcTransport)
        console.log("balancingBuffer", this.form.balancingBuffer)
        console.log("heat rate", this.form.heatRate)
        console.log("heat rate / 1000", this.form.heatRate/1000)
        console.log("other cost", this.form.otherCost)
        console.log("operating margin", this.form.operatingMargin)
        console.log("startup margin", this.form.startupMargin)
        */

      let pricing =
        parseFloat(this.totals.commodityPrice) +
        parseFloat(this.form.ldcTransport) +
        parseFloat(this.form.balancingBuffer)
      let costs =
        parseFloat(this.form.otherCost) +
        parseFloat(this.form.operatingMargin) +
        parseFloat(this.form.startupMargin)
      this.totals.bidPrice =
        parseFloat(pricing) * (parseFloat(this.form.heatRate) / 1000.0) +
        parseFloat(this.form.otherCost) +
        parseFloat(this.form.operatingMargin) +
        parseFloat(this.form.startupMargin)
      this.totals.costToRun =
        parseFloat(pricing) * (parseFloat(this.form.heatRate) / 1000.0) +
        parseFloat(this.form.otherCost) +
        parseFloat(this.form.operatingMargin)
    },

    saveMeta() {
      this.calculate()
      this.updateConstraints()
      //   this.save()
    },
    saveComponent() {
      this.calculate()
      if (this.editedIndex > -1) {
        Object.assign(this.components[this.editedIndex], this.editedItem)
      } else {
        this.components.push(this.editedItem)
      }
      this.close()
    },
    updateConstraints() {
      if (this.bidPriceConstraint != null) {
        this.updateBidPrice()
      }
      if (this.costToRunConstraint != null) {
        this.updateCostToRun()
      }
    },
    updateBidPrice() {
        let obj = {
          master_constraint_id: this.bidPriceConstraint.master_constraint_id,
          facility_id: this.bidPriceConstraint.facility_id,
          value: this.totals.bidPrice
        }
        // console.log('bid price obj', obj)
        ConstraintService.updateFacilityConstraint(obj)
          .then( this.$toast.success("'Bid Price' saved. ") )
          .catch(error => {
            this.$toast.error("Unable to save 'Bid Price' :" + error.message); })
    },
    updateCostToRun() {
        let obj = {
          master_constraint_id: this.costToRunConstraint.master_constraint_id,
          facility_id: this.bidPriceConstraint.facility_id,
          value: this.totals.costToRun
        }
        // console.log('cost to run obj', obj)
        ConstraintService.updateFacilityConstraint(obj)
          .then( this.$toast.success("'Cost to Run' saved." ) )
          .catch(error => {
            this.$toast.error("Unable to save 'Cost to Run' :" + error.message); })
      }
    }
  }
</script>
